import React from "react";
import Cleave from "cleave.js/react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const NumberField = (props: any) => {
  const {
    placeholder,
    value,
    register,
    errors,
    label,
    setValue,
    clearErrors,
    disabled = false,
  } = props;
  return (
    <div className={tw`w-full my-1 text-left`}>
      <label htmlFor="" className={tw`whitespace-nowrap`}>
        {label}
      </label>
      <Cleave
        type="text"
        className={tw`w-full  focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        onBlur={(e) => clearErrors(register.name)}
        onChange={(e) => setValue(register.name, e.target.value)}
        disabled={disabled}
        options={{
          numeral: true,
          numeralDecimalMark: ".",
          numeralDecimalScale: 6,
          numeralPositiveOnly: true,
          delimiter: "",
        }}
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default NumberField;
